<div>
    <mat-dialog-content class="">
      <button (click)="closeDialogue()" class="m-show m-back-arrow" type="button">
        <img src="assets/img/m-back-arrow-dark.svg" alt="" />
      </button>
      <div class="font-14 heading">
        <h4>
          {{ data?.message
          }}<span
            ><button class="closeButton m-hide" (click)="closeDialogue()" type="button">
              X
            </button></span
          >
        </h4>
      </div>
      <div class="assessment_py-10 font-8">
        {{ panelTitle }}
      </div>
      <form *ngIf="loginWith == 'phoneNumber'" [formGroup]="loginForm" (submit)="loginWithPassword()">
        <div class="setup-account-input-icons">
          <img
            class="setup-account-icon"
            src="assets/img/phone-icon.svg"
            alt=""
          />
          <input
            class="form-control setup-account-input-field-left"
            type="text"
            formControlName="phone"
            id="phone1"
            placeholder="Phone Number"
            autofocus
          />
          <mat-error
            class="error-msg"
            *ngIf="l.phone.touched && l.phone.errors?.minlength"
          >
            Mobile number should be 10 digits
          </mat-error>
        </div>
        <div class="setup-account-input-icons">
          <img
            class="setup-account-icon"
            src="assets/img/password-lock.svg"
            alt=""
          />
          <input
            oncopy="return false"
            onpaste="return false"
            class="form-control setup-account-input-field-left"
            [type]="show_button ? 'text' : 'password'"
            formControlName="password"
            placeholder="Password"
          />
          <mat-icon
            class="font-16 cursor-pointer field-icon"
            matSuffix
            (click)="showPassword()"
            >{{ show_button ? "visibility_off" : "visibility" }}</mat-icon
          >
  
          <mat-error
            class="error-msg"
            *ngIf="l.password.touched && l.password.errors?.required"
          >
            Required
          </mat-error>
          <mat-error
            class="error-msg"
            *ngIf="l.password.touched && l.password.errors?.minlength"
          >
            Password should be atleast 6 characters
          </mat-error>
          <mat-error class="UnauthorizedErrorMessage">{{
            UnauthorizedLoginMessage
          }}</mat-error>
        </div>
  
        <div class="form-group phn-input">
          <a class="font-w6" style="color: #0c9968" (click)="forgotPassword()"
            >FORGOT PASSWORD?</a
          >
        </div>
        <button
          class="btn btn-primary btn-block"
          type="submit"
        >
          LOGIN
        </button>
      </form>
  
      <div class="assessment_pt-10">
        <button
          class="btn btn-block"
          style="color: #0c9968"
          (click)="loginWithOtp({dialCode: this.data.countryCode, number:  this.data.phone})"
          type="button"
        >
          LOGIN WITH OTP
        </button>
      </div>
    </mat-dialog-content>
  </div>
  